import { CardMedia } from '@mui/material';
import { Box } from '@mui/system';
import { Copy } from '../../copy/Copy';
import { useWindowSize } from '../../hooks/useWindowSize/useWindowSize';
import { HelperLink } from '../HelperLink/HelperLink';
import { centerText16pxMarginSx } from '../../styles/Global.style';
import { spotifyCardSx } from './SpotifyCard.style';

export const SpotifyCard = ({ playlist }) => {
  const { windowSize } = useWindowSize();
  const height = windowSize.appInnerHeight - 75;
  const spotifyId = playlist?.split('/')[4].split('?')[0];

  const navToSpotify = () => (window.location.href = playlist);

  return (
    <Box>
      <CardMedia
        component="iframe"
        title="Beats4MentalHealth"
        src={`https://open.spotify.com/embed/playlist/${spotifyId}?utm_source=generator&theme=0`}
        width="100%"
        height={height}
        frameBorder="0"
        allowFullScreen=""
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        loading="lazy"
        sx={spotifyCardSx}
      />

      <HelperLink
        to="#"
        textIdentifier="Links.spotifyInvite"
        linkText={Copy.generate('Global.addSongs')}
        onClick={navToSpotify}
        sx={centerText16pxMarginSx}
      />
    </Box>
  );
};
